export const EXTERNAL_HELP_RESOURCE_PAGE_URL =
	'https://www.purdue.edu/innovativelearning/supporting-instruction/instructional-technology/circuit.aspx'
